import { Container as _Container, ContainerProps as _ContainerProps } from "reactstrap";

    export const Container = _Container;
    export type ContainerProps = _ContainerProps;
    